import React, { useState, useEffect, useRef } from "react";
import {Input, Col, Row, Form, Checkbox, Select, Button, notification, Upload, Modal} from 'antd';
import {DownloadOutlined, PlusOutlined, UploadOutlined} from '@ant-design/icons';
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { defaultValidateMessages } from "./Helper";
import config from "../../util/ApiforContext";
import ScreenOptions from "../../util/Extensions/Screens";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const FirmAccountAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [bankDropdown, setbankDropdown] = useState([]);
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [bankBranchDropdown, setbankBranchDropdown] = useState([]);
  const [accountNumber, setAccountNumber] = useState("");
  const [iban, setIban] = useState("");
  const form = props.form;
  const [fileList, setFileList] = useState([]);
  const [tenantAccounts, setTenantAccounts] = useState({
    data: [],
    loading: false
  });

  const [currencyId, setCurrencyId] = useState(1);
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: false,
  });
  const [showAccountsSelect, setShowAccountsSelect] = useState(false);
  const [ibanDisabled, setIbanDisabled] = useState(false);
  const [isManualIban, setIsManualIban] = useState(false);
  const [isVirmanAccount, setIsVirmanAccount] = useState(false);


  const [showOtpModal, setShowOtpModal] = useState(false);
  const [isVerifyOtp, setIsVerifyOtp] = useState(false);
  const [startInterval, setStartInterval] = useState(false);


  const [confirmLoading, setConfirmLoading] = useState(false);

  const [showRetryButton, setShowRetryButton] = useState(false);
   const [errorText, setErrorText] = useState("");

  const [seconds, setSeconds] = useState(180);
  const [otpInput, setOtpInput] = useState("");


    const ref = useRef();
    const intervalRef = useRef(null);

  useEffect(() => {
    RequestHandler.get(`/Bank?$filter=isEmoney ne true&$orderby=name`).then(res => {
      setbankDropdown(res.value.filter(x => x.id !== 999))
    });

    getCurrencies();

    RequestHandler.get("/User/MenuPermissions").then((response) => {
      if(response.modules.includes(1) && props.isSendTosVirmanUnApproved) {
        setShowAccountsSelect(true);
        getTenantAccounts();
        setIsVirmanAccount(true);
      }
    });


  }, []);


    useEffect(() => {
      if (showOtpModal) {
        setSeconds(180);

        intervalRef.current =  setInterval(() => {

          setSeconds((prev) => {

            let second = prev - 1;

            if(second === 0) {
              clearInterval(intervalRef.current);
              setShowRetryButton(true);

              return 0;
            }

            return second;
          });
        }, 1000)
      }
      else {

        clearInterval(intervalRef.current);
      }
    }, [showOtpModal, startInterval])

  useEffect(() => {

    if (props.data?.accountNumber) {
      setAccountNumber(props.data?.accountNumber);
    }
    if (props.data?.iban) {
      setIban(props.data?.iban);
    }

    if (props.data?.firmId) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(`/Firm?$select=id,firmBranchNumber,name&$filter=id eq ${props.data.firmId}`).then(res => {
        setFirmSelect({ data: res.value, loading: false });
      });
    }

    if (props.data) {
      form.setFieldsValue(props.data);
    }

  }, [props.data]);


  const getTenantAccounts = () => {
    RequestHandler.get(
      `/TenantAccount?$select=id,iban,currencyId,accountNumber,name,bankId,branchCode, firmId,accountSuffix, virmanIban&$filter=isManualAccount eq false and isSystemAccount eq false`
    ).then((res) => {

      setTenantAccounts({
        data: res.value,
        loading: false,
      });
    });
  }

  const onChangeAccount = (value) => {
    setIsManualIban(false);
    const tenantAccount = tenantAccounts.data.filter(x=> x.id === value);

    if(tenantAccount.length > 0) {
      const account = tenantAccount[0];

       RequestHandler.get(`/BankBranch/GetBranchForBank?id=${account.bankId}`).then(res => {
          setbankBranchDropdown(res);
        });

      RequestHandler.get(`/BankBranch?$filter=code eq '${account.branchCode}' and bankId eq ${account.bankId}`).then(res => {
        setbankBranchDropdown(res.value);

        form.setFieldsValue({"bankBranchId":  res.value[0]?.id})

      });

        if(account.firmId) {
          RequestHandler.get(`/Firm?$select=id,firmBranchNumber,name&$filter=id eq ${account.firmId}`).then(res => {
            setFirmSelect({ data: res.value, loading: false });

            form.setFieldsValue({"firmId": res.value[0]?.id});

          });
        }


        if(account.iban || account.virmanIban) {
          setIbanDisabled(true);
        }
        else {
          setIbanDisabled(false);
        }

        form.setFieldsValue({  "bankId": account.bankId, "iban": account.iban ?? account.virmanIban, "accountNumber": account.accountNumber, "currencyId": account.currencyId });
    }
  }

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });

    RequestHandler.get(`/Currency?$select=id,code`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
    });
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(`/Firm?isFilter=true&$select=id,firmBranchNumber,name&$filter=${odata.contains("name", value)} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onBankChange = (value) => {
    RequestHandler.get(`/BankBranch/GetBranchForBank?id=${value}`).then(res => {
      setbankBranchDropdown(res);
    });
  }

  const onChangeIban = (value) => {
    setIsManualIban(true);
    setIban(value.target.value);
  }

  const onChangeAccountNumber = (value) => {

    setAccountNumber(value.target.value);
  }

  const onSuccess = () => {
    form.resetFields();

    if (props.onSuccess) props.onSuccess();
  };

  const onOtpConfirm = () => {
    ref.current.submit();
  }

  const handleCancelOtpModal = () => {
    setShowOtpModal(false);
    setLoading(false);
    setStartInterval(false);
    setShowRetryButton(false);
  };

   const otpFormFinish = (values) => {
      setConfirmLoading(true);
      setErrorText("");
      clearInterval(intervalRef)



      RequestHandler.post(
        `/Otp/Verify`,
        {
           OtpType: "FirmAccount",
           Code: values.otp
        },
        false
      ).then((res) => {
        if(res){
          setShowOtpModal(false);
          setConfirmLoading(false);
          setShowRetryButton(false);
          setIsVerifyOtp(true);

          form.submit();
        }else{
          setConfirmLoading(false);
          setErrorText("Doğrulama kodu yanlış. Lütfen tekrar deneyiniz.");
        }
      });
    }

   const sendOtp = () => {
       const smsValue = {
        otpType: "FirmAccount",
        smsText: "TÖS virman hesabı eklemek için doğrulama kodunuz. {code}",
        minutes: 3
      };

      RequestHandler.post("/Otp", smsValue, false).then(response => {

        setShowOtpModal(response);
      });

    }


  const onChangeOtpValue = (e) => {
    setErrorText("")
    setOtpInput(e.target.value)
  }

  const onFinish = values => {

    if(isVirmanAccount && isManualIban && !isVerifyOtp) {
     sendOtp();

      return;
    }

    RequestHandler.post(`/FirmAccount`, values).then(response => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onChangeCurrencyId = (value) => {
    setCurrencyId(value);
  }

  const onFinishFailed = () => setLoading(false);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  const downloadExcelTemplate = () => {
    window.open(
      `${
        config.apiUrl
      }/FirmAccount/DownloadExcelTemplate?t=${RequestHandler.getToken()}`
    );
  };

  const downloadImportResult = (fileName) => {
    window.open(
      `${
        config.apiUrl
      }/FirmAccount/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}`
    );
  };

  const uploadExcelProps = {
    name: "excel",
    action: `${config.apiUrl}/FirmAccount/ImportExcel`,
    headers: {
      Authorization: "bearer " + RequestHandler.getToken(),
      ScreenOption: ScreenOptions.screen,
    },
    accept: ".xlsx",
    maxCount: 1,
    onChange(info) {
      setFileList(info.fileList);
      const { response, status } = info.file;

      if (status !== "error" && status !== "done") return;
      if (!response) return;

      const notificationType = response.success ? "success" : "error";

      notification[notificationType]({
        message: response.message,
        duration: 3,
      });
      if (!response.success) {
        downloadImportResult(info.file.response.data);
      }
      onSuccess();
    },
  };

  const { Option } = Select;
  return (
    <>
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="firmAccountAdd"
      initialValues={{
        remember: true,
        currencyId: 1
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>

        <Col span={24}>

          <Form.Item
            label="Cari Adı/Ünvanı"
            name="firmId"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              placeholder="En az 2 harf giriniz.."
              optionFilterProp="children"
              onSearch={onFirmSearch}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={firmSelect.loading}
            >
              {firmSelect.data.map(item => (
                <Option key={item.id} value={item.id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Tanım Adı" name="title">
            <Input maxLength={250} placeholder="Hesap tanım adı (opsiyonel)" />
          </Form.Item>

          {showAccountsSelect ? <>

            <Form.Item
              label="Hesaplar"
              name = "accountId"
              dependencies={['isTosVirmanAccount']}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    // Checkbox seçili ise accounts zorunlu olsun
                    if (getFieldValue('isTosVirmanAccount')) {
                      if (!value || value.length === 0) {
                        return Promise.reject('Hesap seçimi zorunludur');
                      }
                    }
                    return Promise.resolve();
                  }
                })
              ]}
            >
              <Select
                showSearch
                placeholder="En az 2 harf giriniz.."
                optionFilterProp="children"
                onChange={onChangeAccount}
              >
                {tenantAccounts.data.map(item => (
                  <Option key={item.id} value={item.id}>{item.name ? `${item.name}-`: ''} {item.iban ? `${item.iban}` :  item.accountNumber ?`${item.accountNumber}${item.accountSuffix ? `-${item.accountSuffix}` : ''}` : ''}</Option>
                ))}
              </Select>
            </Form.Item>


          </> : <></>}

          <Form.Item
            label="Banka"
            name="bankId"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              placeholder="Seçiniz."
              optionFilterProp="children"
              onChange={onBankChange}
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {bankDropdown.map(item => (<Option key={item.id} value={item.id}>{item.name}</Option>))}
            </Select>
          </Form.Item>

          <Form.Item
            name="currencyId"
            label="Para Birimi"
            rules={[{ required: true }]}
          >
            <Select
              allowClear
              showSearch
              onChange={onChangeCurrencyId}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {currencySelect.data.map(({ id, code }) => (
                <Select.Option key={id} value={id}>
                  {code}
                </Select.Option>
              ))}

            </Select>
          </Form.Item>

          <Form.Item
            label="Iban"
            name="iban"
            onChange={onChangeIban}
            rules={accountNumber.length < 9 ? [
              { required: true },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();
                  const cleaned = value.replace(/\s+/g, "").toUpperCase();
                  if (cleaned.length !== 26) return Promise.reject('IBAN 26 karakter olmalıdır.');
                  if (!/^TR\d{2}[A-Z0-9]{22}$/.test(cleaned)) return Promise.reject('IBAN formatı geçersiz. TR ile başlamalı ve ardından 24 alfanumerik karakter gelmelidir.');
                  return Promise.resolve();
                }
              },
            ] : null}
          >
            <Input type="text" onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} defaultValue="TR" maxLength="26" disabled={ibanDisabled} />
          </Form.Item>

          <Form.Item
            label="Banka Şubesi"
            name="bankBranchId"
            rules={iban.length < 20 ? [{ required: true },] : null}
          >
            <Select
              showSearch
              placeholder="Seçiniz"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {bankBranchDropdown.map(item => (
                <Option key={item.id} value={item.id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Hesap Numarası"
            name="accountNumber"
            rules={iban.length < 20 ? [{ required: true }, { min: 7 }] : null}
          >
            <Input maxLength="17" onChange={onChangeAccountNumber} onInput={maxLengthCheck} />
          </Form.Item>

          <Form.Item
            label="Geçerli Hesap"
            name="isDefault"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>

          {
            props.isSendTosVirmanUnApproved ? <>
              <Form.Item
                label="Tös Virman Hesabı"
                name="isTosVirmanAccount"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </> : <></>
          }


          <Row justify="space-between">
             {
              props.activeTab == 1 ? <><Col></Col></> : <> <Col>
                <Button
                  icon={<DownloadOutlined />}
                  onClick={(() => setLoading(true), downloadExcelTemplate)}
                  loading={loading}
                >
                  Excel Şablonu İndir
                </Button>
                <Upload {...uploadExcelProps} fileList={fileList}>
                  <Button icon={<UploadOutlined />}>Excel ile Ekle</Button>
                </Upload>
              </Col></>
            }
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>

        </Col>
      </Row>
    </Form>

     <Modal maskClosable={false} visible={showOtpModal} onOk={onOtpConfirm} okText="Onayla" keyboard={false} cancelText="İptal" onCancel={handleCancelOtpModal} confirmLoading={confirmLoading}>
        <p style={{ marginTop: 10, textAlign: 'center', fontSize: 16 }}> Lütfen telefonunuza gelen şifreyi <b>{seconds}</b> saniye içinde girin; </p>

        <Form
          onFinish={otpFormFinish}
          fields={[
            { name: "otp", value: otpInput },
          ]}
          ref={ref}
        >
          <Form.Item
            name="otp"
          >
            <Input onChange={onChangeOtpValue} type='text' maxLength={6}
                   autoComplete="off"
                   style={{ marginTop: 40 }} onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
              if (event.key === "Enter") {
                ref.current.submit();
              }
            }} />


          </Form.Item>
          <Row style={{ marginBottom: -25 }}>
            <Col span={17}></Col>
            <Col span={7}>
              {
                showRetryButton ? <>
                  <Button onClick={sendOtp}>
                    Tekrar Gönder
                  </Button>
                </> : <></>
              }

            </Col>
          </Row>
        </Form>
        <p style={{ color: 'darkred', textAlign: 'center', fontWeight: 600, marginTop: 10 }}>{errorText}</p>
      </Modal>
    </>
  )
}
export default FirmAccountAddForm
